@if (alertMessage()) {
  <div class="employee-alert">
    <ui-alert [alert]="alertMessage()"></ui-alert>
  </div>
}

@if (employees(); as employees) {
  <div class="employee-list-content">
    <ui-employee-list
      [employees]="employees"
      (renewInvitationClicked)="onRenewInvitationClicked($event)"
      (editClicked)="onEditClicked($event, editSide)"
      (deleteClicked)="onDeleteClicked($event)"
    ></ui-employee-list>
  </div>
}
<div class="employee-list-footer">
  <ui-button data-testid="invite-button" (clicked)="inviteSide.open()">+ Mitarbeiter einladen</ui-button>
</div>

<ng-template #deleteConfirmationContent>
  <p>
    Möchten Sie den Mitarbeiter <strong>{{ deleteConfirmationEmployeeEmail() }}</strong> wirklich löschen?
  </p>
</ng-template>

<ng-template uiSideSheetSide="right" #inviteSide="SideSheetDirective">
  <ui-side-sheet-header (closeSideSheet)="inviteSide.close()">Mitarbeiter einladen</ui-side-sheet-header>
  @if (delegatableRoles(); as roles) {
    <ui-employee-invite
      [customer]="currentCustomer()"
      [roles]="roles"
      (cancelClicked)="inviteSide.close()"
      (submitResult)="onInviteSubmit($event, inviteSide)"
    ></ui-employee-invite>
  }
</ng-template>

<ng-template uiSideSheetSide="right" #editSide="SideSheetDirective">
  <ui-side-sheet-header (closeSideSheet)="onEditCancel(editSide)">Mitarbeiter bearbeiten</ui-side-sheet-header>
  @if (editingEmployee(); as employee) {
    <ui-employee-edit
      [employee]="employee"
      (cancelClicked)="onEditCancel(editSide)"
      (submitResult)="onEditSubmit($event, editSide)"
    ></ui-employee-edit>
  }
</ng-template>

